import unauthAxios from "../axios";

// Fire-and-forget beacon recording a referral-link click. Server dedupes per IP per day.
export const trackLinkClick = (ref, refId) =>
  unauthAxios.post("/v1/link-click", { ref, ref_id: refId });


